import { render } from "./PayAudioLibraryEditModal.vue?vue&type=template&id=0d20a10c&scoped=true"
import script from "./PayAudioLibraryEditModal.vue?vue&type=script&lang=js"
export * from "./PayAudioLibraryEditModal.vue?vue&type=script&lang=js"

import "./PayAudioLibraryEditModal.vue?vue&type=style&index=0&id=0d20a10c&scoped=true&lang=less"
import "./PayAudioLibraryEditModal.vue?vue&type=style&index=1&id=0d20a10c&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d20a10c"]])

export default __exports__